import { useState, useEffect, useContext } from "react"
import { useDispatch, useSelector } from "react-redux"
import JobApplicationProcess from "./JobApplicationProcess"
import InternalAssessmentForm from "./InternalAssessmentForm"
import ApiConfig from "../api/ApiConfig"
import { simpleGetCall, PostCallWithErrorResponse, simplePostCall, simplePostTokenCall } from "../api/ApiServices"
import roundtoSlice, { updateData } from "../redux/roundtoSlice"
import { toast } from "react-toastify"
import { json, useNavigate, useSearchParams } from "react-router-dom"
import { getBrowser } from "../constant/getBrowser"
import { getOS } from "../constant/getOS"
import { AppContext } from "../contaxt/AppContext"
import { isValidEmail } from "../common"
import { Modal } from "react-bootstrap";
import CustomButton from "../components/customButton"



function ApplicationProcess() {

  const state = useSelector(state => state.roundData)
  const dispatch = useDispatch()
  const [isNotFilledData, setIsNotFilledData] = useState(false)
  const {
    isQuizWeb,
    getUserProgress,
    ishowMessgLogn,
    setIsShowMsgLgn,
    displayMsg,
    setDisplayMsg,
    isNotIntested,
    setIsNotIntersted,
    handleStep
  } = useContext(AppContext)
  const [departments, setDepartments] = useState([])
  const [indutries, setIndutries] = useState([])
  const [specialization, setSpecialization] = useState([])
  const [customQuestion, setCustomQuestions] = useState([])
  const [isMobileView, setIsMobileView] = useState(null);
  const [isApiCalled, setIsApiCalled] = useState(false)
  const [duplicateFount, setIsDuplicateFound] = useState({})
  const [isRedirect, setIsRedirect] = useState(false)


  const [params] = useSearchParams()

  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  const today = new Date();
  const futureDate = new Date();
  futureDate.setDate(today.getDate() + 30);
  const [isSubmitedError, setIsSubmitedError] = useState('')
  const [isUserExist, setIsUserExist] = useState(false)


  const initialDetail = {
    name: "",
    email: "",
    no: "",
    countryCode: "+91",
    availableFrom: futureDate.toISOString().slice(0, 10),
    currentLocation: "",
    code: "",
    currentCompany: "",
    currentIndustry: "",
    departmentId: "",
    currentJobTittle: "",
    customQuestion1: "",
    customQuestion2: "",
    customQuestion3: "",
    educationlevel: 0,
    expectedSalary: "12 to 15 Lakhs per yea",
    experinces: "",
    fieldOfEducation: 0,
    noticePeriodbuyoptions: false,
    uploadResume: "",
    uploadResumeName: "",
    userId: 0,
    expectedSalary: ''

  };

  const [details, setDetails] = useState(initialDetail);

  const handleGoBack = () => {
    navigate(-1);

    dispatch(updateData({ field: "isEditDetails", value: false }));
  };

  const getIndutryList = () => {
    simpleGetCall(ApiConfig.GET_INDUSTRY_LIST).then((res) => {
      if (res?.succeded) {
        setIndutries(res?.response);
      }
    });
  };

  const getCompanydetails = () => {
    simpleGetCall(ApiConfig.GET_COMAPNY_ABOUT_JOB + state.code).then((res) => {
      if (res?.succeded) {
        dispatch(
          updateData({
            field: "aboutCompany",
            value: res?.response?.aboutcompany,
          })
        );
        dispatch(
          updateData({ field: "aboutJob", value: res?.response?.aboutjob })
        );
        dispatch(
          updateData({ field: "position", value: res?.response?.jobtitle })
        );
        dispatch(
          updateData({
            field: "companyLogo",
            value: res?.response?.companylogo,
          })
        );
        dispatch(
          updateData({
            field: "companyname",
            value: res?.response?.companyname,
          })
        );
      }
    });
  };

  const getDepartments = () => {
    simpleGetCall(ApiConfig.GET_DEPARTMENTS).then((res) => {
      if (res.succeded) {
        setDepartments(res?.response);
      }
    });
  };

  const getSpecialization = () => {

    simpleGetCall(
      `${ApiConfig.GET_SPECIALIZATIONS}?currentUserId=${0}&token=${""}`
    ).then((res) => {

      if (res?.succeded) {
        setSpecialization(res?.response)
      }

    })
  }

  const getUserDetails = (userId = '', changeDetails = false) => {

    let id = userId ? userId : state.userId


    simpleGetCall(ApiConfig.GET_ADDITIONINFO + '?UserId=' + id + '&code=' + state.code,).then((res) => {

      if (!changeDetails) {
        res.response.name = res?.response?.userName
        res.response.no = res?.response?.mobile
      } else {
        res.response.email = details?.email
        res.response.no = details?.no
        res.response.name = details.name
      }


      res.response.noticePeriodbuyoptions = res.response.noticePeriodbuyoptions ? 'Yes' : 'No'
      res.response.fieldOfEducation = res.response.specializationId
      res.response.uploadResumeName = res.response.uploadResume
      res.response.experinces = res?.response?.experinces === 0 ? "0" :
        res?.response?.experinces >= 30 ? '30' :
          Math.floor(parseFloat(res?.response?.experinces)) + ''
      delete res?.response?.uploadResume


      if (res?.response?.mobile?.length === 0) {
        setDetails(prev => ({
          ...prev,
          email: res?.response?.email
        }))
        return
      }

      if (res?.succeded) {
        setDetails(res?.response);

        if (state.applicationType === "Job Application") {
          document.getElementById("UploadResumeInput").value =
            res?.response?.uploadResume ? res?.response?.uploadResume : "";
        }
      }
    });
  };

  const getCustomQuestions = () => {
    simpleGetCall(
      ApiConfig.GET_CUSTOM_QUESTIONS + `?jobcode=${state.code}`
    ).then((res) => {
      if (res?.succeded) {
        setCustomQuestions(res?.response);
      }
    });
  };

  useEffect(() => {
    getCompanydetails();
    getIndutryList();
    getSpecialization();
    getDepartments();

    if (state.applicationType == "Job Application") {
      getCustomQuestions();
    }




  }, [])

  useEffect(() => {

    const isRedirect = params.get("isRedirect")

    setIsRedirect(isRedirect)

    if ((state.userId && state.token && isRedirect) || state.isEditDetails) {

      getUserDetails()

    }

  }, [state.token])

  useEffect(() => {

    // if (details.no.length > 14 || details?.no?.length < 9) return

    if (details?.email) {
      const delayDebounce = setTimeout(() => {
        createUser();
      }, 2000);

      return () => clearTimeout(delayDebounce);
    }

  }, [details.email])


  const handleUserCreateOnNo = () => {
    if (details.no.length > 14 || details?.no?.length < 9) {
      setErrors(prev => ({
        ...prev,
        no: 'Please Enter Valid No'
      }))
      return
    }

    createUser()
  }

  const handleValidedEmailMsg = () => {
    if (!isValidEmail(details?.email)) {
      setErrors(prev => ({
        ...prev,
        email: 'Please Enter Valid Email'
      }))
    }
  }



  useEffect(() => {


    isMobile();
    window.addEventListener("resize", isMobile);
    return () => {

      window.removeEventListener("resize", isMobile);
    };


  }, []);

  const isMobile = () => {
    return window.innerWidth <= 768
      ? setIsMobileView(true)
      : setIsMobileView(false);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!details?.name?.trim()) newErrors.name = "Please Enter Name";
    if (!isValidEmail(details.email)) newErrors.email = "Please Enter Email";
    if (details?.no?.trim().length < 9 || details.no?.trim().length > 14)
      newErrors.no = "Please Enter Phone number";

    if (!details.experinces?.trim()) newErrors.experinces = "Please Select Experience ";


    if (details.experinces != "0") {

      if (!details?.currentJobTittle?.trim() && details.experinces != "0")
        newErrors.currentJobTitle = "Please Enter Current job title ";

      if (!details.departmentId)
        newErrors.currentDepartment = "Please Select Department";
    }



    if (state.applicationType == "Job Application") {

      if (!details.educationlevel)
        newErrors.educationLevel = "Please Select Education level";
      if (!details.fieldOfEducation)
        newErrors.fieldOfEducation = "Please Select Field of education";

      if (details.experinces != "0") {
        if (!details?.currentCompany?.trim())
          newErrors.currentCompany = "Please Enter Current company";
        if (!details.currentIndustry)
          newErrors.currentIndustry = "Please Select Current industry";

      }


      if (!details?.expectedSalary) newErrors.expectedSalary = "Please Select Expected Salary"

      if (!details.availableFrom)
        newErrors.availableFrom = "Please Select Available from date";
      if (!details.currentLocation)
        newErrors.currentLocation = "Please Enter Current Location";
      if (!details.noticePeriodbuyoptions)
        newErrors.buyOutOption = "Please select an option";


      customQuestion.map((ques, index) => {
        if (!ques?.isActive) return;

        let fieldName = `customQuestion${index + 1}`;

        console.log(details["customQuestion4"]);

        if (details[fieldName]?.length === 0 || !details[fieldName]) {
          newErrors[fieldName] = "Please Select Answer";
        }



      });

      if (!details.uploadResumeName) newErrors.resume = "Resume is required";
    }

    setErrors(newErrors);

    console.log(newErrors);

    if (Object.keys(newErrors).length === 0) return true

    setIsNotFilledData(true)

    const firstErrorFieldName = Object.keys(newErrors)[0];


    if (firstErrorFieldName) {
      const el = document.getElementsByName(firstErrorFieldName)[0];
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        // el.focus();
      }
    }


  };

  const saveAdditionalDetails = () => {
    let detls = { ...details };

    detls.userId = Number(state.userId);
    detls.noticePeriodbuyoptions = details.noticePeriodbuyoptions === "no";
    detls.code = state.code;


    if (state.isEditDetails) {

      delete detls.specializationId
      delete detls.primaryProfile
      delete detls.secondaryProfile
    }

    detls.isQuiz = state?.isQuiz
    setIsApiCalled(true);
    simplePostCall(ApiConfig.SUBMIT_ADDITIONINFO, JSON.stringify(detls)).then(
      (res) => {
        if (res?.succeded) {
          dispatch(updateData({ field: "userName", value: details.name }));
          dispatch(updateData({ field: "userEmail", value: details.email }));
          toast.success(res?.response?.statusMessage);
          setIsApiCalled(false);


          if (state.isEditDetails && !isRedirect) {
            handleGoBack();
          } else {
            if (isQuizWeb) {
              navigate(
                `/LywoApplicattion2?jobcode=${state.code}&&userId=${detls.userId}`
              );
            } else {
              if (state.applicationType === "Job Application") {
                dispatch(updateData({ field: 'step', value: 1 }))
                navigate("/LywoApplicationStatus");
              } else {
                navigate("/CompanyName");
              }
            }

            dispatch(updateData({ field: "isEditDetails", value: false }));
          }
        } else {
          toast.error(res?.response?.statusMessage);
        }

        setIsApiCalled(false);
      }
    );
  };


  const getToken = async (userId = "", otp = '') => {
    let payload = {
      email: details.email,
      name: details.name,
      mobileNumber: details.no,
      UniqueCode: state.code,
      languagePrefrence: null,
      view: isMobileView ? "mobile" : "desktop",
      browser: getBrowser(),
      os: getOS(),
    };

    let tokenPayload = {
      userId: userId ? userId : state?.userId,
      companyId: 0,
      roleId: 3,
      otp: userId ? otp : state?.otp,
    };

    const urlEncodedData = new URLSearchParams(tokenPayload).toString();
    let token = await simplePostTokenCall(
      ApiConfig.TOKEN_ACCESS,
      urlEncodedData,
      JSON.stringify(payload)
    );

    if (!token.token) {
      return;
    }

    localStorage.setItem("authToken", token.token);
    localStorage.setItem("Uniquecode", state.code);

    dispatch(updateData({ field: "token", value: token.token }));


  }

  const userCreate = async () => {


    let payload = {
      email: details.email,
      name: details.name,
      mobileNumber: details.no,
      UniqueCode: state.code,
      languagePrefrence: null,
      view: isMobileView ? "mobile" : "desktop",
      browser: getBrowser(),
      os: getOS(),
    };

    let res = await PostCallWithErrorResponse(
      ApiConfig.REGISTRATION_FORM,
      payload
    );



    localStorage.setItem("customer_id", res?.json?.response[0]?.userId);
    dispatch(
      updateData({ field: "userId", value: res?.json?.response[0]?.userId })
    );
    dispatch(
      updateData({ field: "otp", value: res?.json?.response[0]?.otp })
    );

    setIsDuplicateFound(res?.json?.response[0]?.changedDetails)
    let foundDta = res?.json?.response[0]?.changedDetails
    // if (res?.json?.response[0]?.isAssessmentComplete) {
    //   toast.error("Your Application Is Already Submitted!")
    //   setIsSubmitedError("Your Application Is Already Submitted!")
    //   return;
    // }
    setIsSubmitedError('')


    let msg = `Dear Applicant,

You have already started your application using your email / phone. You can continue only by using the link shared to the email ${foundDta?.orginalEmail || details?.email}. Please check your email for the link. Contact admin if you did not receive the email with the link.`

    if ((foundDta?.isEmailChange || foundDta?.isMobileChange) && (details.no.length >= 9 && details?.no?.length <= 14)) {

      setDisplayMsg(msg)

      setIsShowMsgLgn(true)

      setIsUserExist(true)

      getUserProgress(state.code, res?.json?.response[0]?.userId)

      return
      // setMessageFor('')
    } else if ((details.no.length >= 9 && details?.no?.length <= 14) && res?.json?.response[0]?.addInfo) {

      setDisplayMsg(msg)

      setIsShowMsgLgn(true)

      setIsUserExist(true)

      getUserProgress(state.code, res?.json?.response[0]?.userId)
      return
    }

    if (details.no.length > 14 || details?.no?.length < 9) return


    setIsUserExist(false)


    let token = await getToken(res?.json?.response[0]?.userId, res?.json?.response[0]?.otp)



    if (res?.json?.response[0]?.addInfo) {
      getUserDetails(res?.json?.response[0]?.userId, true);
    }
  };

  const handleProceed = async () => {

    if (isUserExist) {
      setIsShowMsgLgn(true)

      return
    }

    if (validateForm()) {
      if (isApiCalled) return;


      saveAdditionalDetails();
    }
  };


  const handleCloseMsg = () => {

    setIsNotIntersted(false)


    setIsShowMsgLgn(false)

    if (state?.isEditDetails) {

      return
    }


    // navigate('/LoginWithCode')

  }

  const isUserExistInJob = () => {

    let payload = {
      "userId": state?.userId,
      "jobcode": state?.code,
      "email": details?.email,
      "mobileNumber": details?.no
    }

    simplePostCall(ApiConfig.CHECK_USER_EXIST_IN_SAME_JOB, JSON.stringify(payload)).then((res) => {



      if (res?.succeded) {

        if (res?.response?.isEmailInCode || res?.response?.isMobileInCode) {

          setDetails(prev => ({
            ...prev,
            email: res?.response?.orginalEmail,
            no: res?.response?.orginalMobile
          }))

          setDisplayMsg('An Application has already been started that match your details (Phone / Email). we will send you a link that you can use to access your application ')
          setIsShowMsgLgn(true)

        }

      }

    })


  }

  const createUser = () => {

    if (
      !isValidEmail(details?.email)
    ) {
      return
    }

    if (details.no.length > 14 || details?.no?.length < 9) return
    if (state?.isEditDetails) {
      isUserExistInJob()
    } else {
      userCreate()
    }

  }


  const updateInterst = () => {

    let payload = {
      "userId": state.userId,
      "jobcode": state?.code,
      "isNotInterested": false,
      "reason": ""
    }

    PostCallWithErrorResponse(ApiConfig.UPDATE_NOT_INTERESTED, payload).then((res) => {
      setIsNotIntersted(false)
      if (res?.json?.succeded) {

        if (state.currentStep === 2) {
          getUserDetails()
          setIsShowMsgLgn(false)
          return
        }

        handleStep(state.currentStep)


      }

    })

  }


  return (
    <>
      {state.applicationType === "Job Application" ? (
        <JobApplicationProcess
          indutries={indutries}
          specialization={specialization}
          details={details}
          setDetails={setDetails}
          handleProceed={handleProceed}
          handleGoBack={handleGoBack}
          customQuestion={customQuestion}
          errors={errors}
          setErrors={setErrors}
          handleUserCreateOnNo={handleUserCreateOnNo}
          isApiCalled={isApiCalled}
          departments={departments}
          isNotFilledData={isNotFilledData}
          isRedirect={isRedirect}
          handleValidedEmailMsg={handleValidedEmailMsg}
        />

      ) : (
        <InternalAssessmentForm
          indutries={indutries}
          specialization={specialization}
          details={details}
          setDetails={setDetails}
          handleProceed={handleProceed}
          handleUserCreateOnNo={handleUserCreateOnNo}
          handleGoBack={handleGoBack}
          errors={errors}
          setErrors={setErrors}
          isApiCalled={isApiCalled}
          departments={departments}
          isNotFilledData={isNotFilledData}
          handleValidedEmailMsg={handleValidedEmailMsg}
        />
      )}
      <Modal
        show={ishowMessgLogn}
        // onHide={handleClosemodal}
        centered
        size="lg"
        dialogClassName="custom-modal"
      >
        <div className="p-4 text-center position-relative">
          {/* Close button */}
          <button
            // onClick={handleClosemodal}
            style={{
              position: "absolute",
              top: "5px",
              right: "5px",
              border: "none",
              background: "transparent",
              fontSize: "20px",
              cursor: "pointer",
              color: "#172B4D"
            }}
            onClick={handleCloseMsg}
          >
            ×
          </button>

          {/* <h5
            className="  mb-3"
            style={{
              color: "#9E2B25",
              fontSize: "23.22px",
              fontWeight: 500,
              lineHeight: "28px",
            }}
          >
            We Found an Existing Record !
          </h5> */}

          <p
            className=" mb-3 mt-2"
            style={{ fontSize: "16px", color: "#172B4D" }}
          >
            {displayMsg}
          </p>

          <div className="d-flex justify-content-center gap-3">
            <div>
              <button
                onClick={isNotIntested ? updateInterst : handleCloseMsg}
                style={{
                  backgroundColor: "#444CE7",
                  color: "#fff",
                  padding: "10px 18px",
                  fontSize: "16px",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              >
                {isNotIntested ? "Interested" : "Ok"}
              </button>
              <br />
              {
                isNotIntested &&

                <button className="mt-1" style={{ color: 'blue', borderBottom: '1px solid blue', cursor: 'pointer' }}
                  onClick={handleCloseMsg}
                >Close</button>
              }
            </div>
          </div>
          {/* <p
            className=" mb-4"
            style={{ fontSize: "16px", color: "#172B4D" }}
          >
            Would you like to update your {duplicateFount?.isEmailChange ? "Email" : "Mobile no"} from{" "}
            <span style={{ color: "#9E2B25", fontWeight: "500" }}>
              {duplicateFount?.isEmailChange ? duplicateFount?.orginalEmail : duplicateFount?.orginalMobile}
            </span>{" "}
            to{" "}
            <span style={{ color: "#444CE7", fontWeight: "500" }}>
              {duplicateFount?.isEmailChange ? details.email : details.no}
            </span>
          </p> */}
          {/* 
          <div className="d-flex justify-content-center gap-3">
            <button
              onClick={async () => {

                if (duplicateFount.isMobileChange) {


                  setDetails(prev => ({
                    ...prev,
                    no: duplicateFount?.orginalMobile
                  }))
                } else {
                  setDetails(prev => ({
                    ...prev,
                    email: duplicateFount?.orginalEmail
                  }))
                }


                setIsDuplicateRecord(false)

              }}
              style={{
                padding: "10px 18px",
                fontSize: "16px",
                border: "1px solid #D0D5DD",
                background: "white",
                color: "#344054",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              No, Keep my old Details
            </button>
      
            <button
              onClick={() => {
                updateUserLoginDetails()

              }}
              style={{
                backgroundColor: "#444CE7",
                color: "#fff",
                padding: "10px 18px",
                fontSize: "16px",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              Yes, Update my detail
            </button>
          </div> */}
        </div>
      </Modal >
    </>
  );
}

export default ApplicationProcess;
